import React from 'react';

import Typography from '../../library/typography/typography';

import { Maybe } from '../../shared/types/graphql-types';

import './minimum-price-message.scss';

interface MinimumPriceMessageProps {
  className?: string;
  message?: Maybe<string>;
}

function MinimumPriceMessage(props: MinimumPriceMessageProps) {
  const { className = '', message } = props;

  return (
    <Typography
      className={`${className} minimum-price-message`}
      size="small"
      styleName="message"
      weight="heavy"
    >
      {message}
    </Typography>
  );
}

export default MinimumPriceMessage;
